import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from 'src/app/extensions/components/components.module';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import '@progress/kendo-angular-intl/locales/ro/all';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { FormsModule } from '@angular/forms';
import { PipeModule } from 'src/app/extensions/pipes/pipe.module';
import { TermsAndConditionsListComponent } from './terms-and-conditions-list/terms-and-conditions-list.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TermsAndConditionsRoutingModule } from './terms-and-conditions-routing.module';
import { TermsAndConditionsListViewComponent } from './terms-and-conditions-list/terms-and-conditions-list-view/terms-and-conditions-list-view.component';
import { TermsAndConditionsDetailComponent } from './terms-and-conditions-detail/terms-and-conditions-detail.component';
import { EditorModule } from '@progress/kendo-angular-editor';
import { TermsAndConditionsConsentListComponent } from './terms-and-conditions-consent-list/terms-and-conditions-consent-list.component';
import { TermsAndConditionsConsentListViewComponent } from './terms-and-conditions-consent-list/terms-and-conditions-consent-list-view/terms-and-conditions-consent-list-view.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    TermsAndConditionsRoutingModule,
    ComponentsModule,
    DateInputsModule,
    FormsModule,
    PipeModule,
    DropDownsModule,
    InputsModule,
    NgbModule,
    EditorModule,
  ],
  declarations: [
    TermsAndConditionsListComponent,
    TermsAndConditionsListViewComponent,
    TermsAndConditionsDetailComponent,
    TermsAndConditionsConsentListComponent,
    TermsAndConditionsConsentListViewComponent,
  ],
})
export class TermsAndConditionsModule {}
